// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ab6ced3b","977":"4e4b4d53"}[chunkId] + ".chunk.js";
};